import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-review-response",
  templateUrl: "./review-response.component.html",
  styleUrls: ["./review-response.component.scss"],
})
export class ReviewResponseComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
